import AffiliateHelper from '@/helper/AffiliateHelper'
import Affiliate from '@/models/Affiliate'
import AdspaceHelper from '@/helper/AdspaceHelper'
import Adspace from '@/models/Adspace'
import ApiKeyHelper from '@/helper/ApiKeyHelper'
import ApiKey from '@/models/ApiKey'
import MultiplierHelper from '@/helper/MultiplierHelper'
import Multiplier from '@/models/Multiplier'
import store from '@/store/index'

export default function () {
  if (store.state.isLogged) {
    AffiliateHelper.load().then((res) => {
      let affiliates = res.map((item) => Affiliate.parserFrom(item).attrs)
      localStorage.setItem('affiliates', JSON.stringify(affiliates))
    })

    AdspaceHelper.load().then((res) => {
      let adspaces = res.map((item) => Adspace.parserFrom(item).attrs)
      localStorage.setItem('adspaces', JSON.stringify(adspaces))
    })

    ApiKeyHelper.load().then((res) => {
      let apikeys = res.map((item) => ApiKey.parserFrom(item).attrs)
      localStorage.setItem('apikeys', JSON.stringify(apikeys))
    })

    MultiplierHelper.load().then((res) => {
      let multipliers = res.map((item) => Multiplier.parserFrom(item).attrs)
      localStorage.setItem('multipliers', JSON.stringify(multipliers))
    })
  }
}
